<div class="wrapper" [ngClass]="{ 'wrapper--not-allowed': disabled }">
  <label class="switch" [ngClass]="{ 'switch--disabled': disabled }">
    <input type="checkbox" #toggleCheckbox [(ngModel)]="value">
    <span class="slider"></span>
  </label>
</div>